/**
 * ClipboardsList
 */
import '../dist/templates/clipping/clipboards-list-item';
import jSecure from "@linkedin/jsecure";

  const ss = window.slideshare_object;
  var $ = window.$,
    utils = ss.utils,
    api = utils.imports('clips.api'),
    hasFoundation = !!$.fn.foundation,

    keys = {
      enter: 13
    },

    EVENT_NAMESPACE = '.clipboardslist',
    events = {
      clipboardSelected: 'clipboard:selected'
    },

    i18n = {
      select: utils.i18n('select'),
      selected: utils.i18n('selected')
    },

    DEFAULT_CONFIG = {
      el: null,
      classes: {
        clipboardItem: 'j-clipboard j-clipboard-item',
        searchHighlight: 'search-highlight'
      },
      selectors: {
        searchInputContainer: '.clipboard-search-input-container',
        searchInput: '.clipboard-search-input',
        clipboardList: '.clipboard-list',
        clipboardItem: '.clipboard-list .clipboard-list-item',
        clipboardItemTitle: '.clipboard-item-title'
      },
      templates: {
        listItem: 'templates.clipping.clipboards-list-item'
      },
      dataAttr: {
        clipboard: 'clipboard-to'
      },
      minItemsToShowSearch: 4
    };

  /**
   * Object that handles user interactions on the clipboards dropdown.
   */
  function ClipboardsList(options) {
    this.api = api;
    this.config = $.extend(true, {}, DEFAULT_CONFIG, options);
    this._$events = $({});

    this.$el = $(this.config.el);

    if (!this.$el.length) {
      console.error('Unable to initialize ClipboardsList');
    } else {
      this._init();
      this._attachEventListeners();
    }
  }

  /**
   * Add docs
   */
  ClipboardsList.prototype._init = function() {
    this.classes = this.config.classes;
    this.selectors = this.config.selectors;
    this.dataAttr = this.config.dataAttr;

    this.templates = {
      listItem: utils.imports(this.config.templates.listItem)
    };

    this.$clipboardList = this.$el.find(this.selectors.clipboardList);
    this.$searchInputContainer = this.$el.find(this.selectors.searchInputContainer);
    this.$searchInput = this.$el.find(this.selectors.searchInput);
  };

  /**
   * Binds all necessary events
   */
  ClipboardsList.prototype._attachEventListeners = function() {
    this.$el.on('input' + EVENT_NAMESPACE, this.selectors.searchInput, this.onSearchClipboards.bind(this));
    this.$el.on('keypress' + EVENT_NAMESPACE, this.selectors.searchInput, this.onSearchKeypress.bind(this));
    this.$el.on('click' + EVENT_NAMESPACE, this.selectors.clipboardItem, this.onClipboardClick.bind(this));
  };

  /**
   * Unbinds all necessary events
   */
  ClipboardsList.prototype._detachEventListeners = function() {
    this.$el.off(EVENT_NAMESPACE);
  };

  /**
   * Sorts the clipboards by the query match.
   * @param {String} query The query
   * @param {String} a The first item being compared
   * @param {String} b The second item being compared
   * @returns {Number}
   */
  ClipboardsList.prototype.sortClipboardsByQueryMatch = function(query, a, b) {
    var aClipboard = $(a).data(this.dataAttr.clipboard),
      bClipboard = $(b).data(this.dataAttr.clipboard),
      aTitle = aClipboard.title.toLowerCase(),
      bTitle = bClipboard.title.toLowerCase(),
      aIndex = aTitle.indexOf(query),
      bIndex = bTitle.indexOf(query);

    if (aIndex !== bIndex) {
      return aIndex - bIndex;
    }

    if (aTitle < bTitle) {
      return -1;
    }

    if (aTitle > bTitle) {
      return 1;
    }

    return 0;
  };

  /**
   * Creates a clipboard title
   * @param {Object} clipboard The clipboard object
   * @param {String} title An optional title
   * @returns {String}
   */
  ClipboardsList.prototype.makeClipboardTitle = function(clipboard, title) {
    title = title || clipboard.title;
    return title;
  };

  /**
   * Creates an element to be used as a title for the searched items
   * @param {Object} clipboard The current clipboard
   * @param {String} query The search query
   * @returns {String} The title
   */
  ClipboardsList.prototype.makeSearchTitle = function(clipboard, query) {
    var title = clipboard.title,
      index = title.toLowerCase().indexOf(query);
    return this.makeClipboardTitle(
      clipboard,
      jSecure.processTemplate(
        '{prefix}<span class="{searchHighlight}">{mid}</span>{suffix}',
        {
          prefix: title.substring(0, index),
          mid: title.substring(index, index + query.length),
          suffix: title.substring(index + query.length),
          searchHighlight: this.classes.searchHighlight
        }
      )
    );
  };

  /**
   * Triggers a selected clipboard event and closes the dropdown
   * @param {Object} e The event object
   */
  ClipboardsList.prototype.onClipboardClick = function(e) {
    var $clipboard = $(e.currentTarget),
      clipboard = $clipboard.data(this.dataAttr.clipboard);

    if (clipboard && !clipboard.checked) {
      this._$events.trigger(events.clipboardSelected, clipboard);
    }
  };

  /**
   * Filters the clipboards dropdown based on the value in the search input
   * @param {Object} e The event object
   */
  ClipboardsList.prototype.onSearchClipboards = function(e) {

    var $target = $(e.target),
      query = $target.val().toLowerCase(),
      $clipboards = $(this.selectors.clipboardItem);

    $clipboards.hide();
    $clipboards.detach();

    $clipboards.sort(function(a, b) {
      return this.sortClipboardsByQueryMatch(query, a, b);
    }.bind(this));

    $clipboards.appendTo(this.$clipboardList);

    $clipboards.each(function(index, clipboard) {
      var $clipboard = $(clipboard),
        $clipboardTitle = $clipboard.find(this.selectors.clipboardItemTitle),
        data = $clipboard.data(this.dataAttr.clipboard),
        title = data.title;

      if (title.toLowerCase().indexOf(query) > -1) {
        $clipboardTitle.html(this.makeSearchTitle(data, query));
        $clipboard.show();
      }
    }.bind(this));

    this.scrollToTop();
  };

  /**
   * Selects the first clipboard on enter
   * @param {Object} e The event object
   */
  ClipboardsList.prototype.onSearchKeypress = function(e) {
    if (e.which !== keys.enter) {
      return;
    }

    var $clipboards = $(this.selectors.clipboardItem + ':visible'),
      $first = $clipboards.first(),
      clipboard = $first.data(this.dataAttr.clipboard);

    if (clipboard) {
      if (clipboard.is_default) {
        this.close();
      } else {
        this._$events.trigger(events.clipboardSelected, clipboard);
      }
    }
  };

  /**
   * Populates the dropdown with the given clipboards
   * @param {Array} clipboards The clipboard list
   */
  ClipboardsList.prototype.updateClipboards = function(clipboards) {
    this.$clipboardList.empty().append(
      clipboards.map(function(clipboard) {
        var itemTempl = this.templates.listItem($.extend(true, {}, {i18n: i18n}, clipboard));
        return $(itemTempl).data(this.dataAttr.clipboard, clipboard);
      }.bind(this))
    );
  };

  /**
   * Updates the search input. The search input will only show if there
   * are enough items in the clipboard list.
   * @param {Array} clipboards The clipboard list
   */
  ClipboardsList.prototype.updateSearchInput = function(clipboards) {
    var useSearch = clipboards.length > this.config.minItemsToShowSearch;
    this.$clipboardList.toggleClass('has-search', useSearch);
    this.$searchInputContainer.toggle(useSearch);
    this.$searchInput.val('');
  };

  /**
   * Updates the clipboards dropdown with the given list of clipboards
   * @param {Array} clipboards The clipboards list
   */
  ClipboardsList.prototype.update = function(clipboards) {
    this.updateClipboards(clipboards);
    this.updateSearchInput(clipboards);
    this.scrollToTop();
  };

  /**
   * Closes the dropdown
   */
  ClipboardsList.prototype.close = function() {
    if (hasFoundation) {
      $(document).foundation('dropdown', 'close', this.$el);
    }
  };

  /**
   * Scrolls the clipboard list to the top
   */
  ClipboardsList.prototype.scrollToTop = function() {
    this.$clipboardList.scrollTop(0);
  };


  /**
   * Sets an event handler for a given event type.
   * @param {string} event The event type to listen for.
   * @param {function} handler The method to invoke.
   */
  ClipboardsList.prototype.on = function(event, handler) {
    this._$events.on(event, handler);
  };


export default ClipboardsList;